import "./form.css"
import React, {useState} from "react";
import {usePumpStore} from "../../store/pumpStore";
import axios from "axios";
import coin from "../../assets/coin.svg";
import {Locales} from "../../helpers/localeHelpers";
import parse from "html-react-parser";
import LanguagePicker from "../language/language";


export const TaskForm = () => {
    const [link, setLink] = useState('')
    const [title, setTitle] = useState('')
    const [correct, setCorrect] = useState('')
    const [answer1, setAnswer1] = useState('')
    const [answer2, setAnswer2] = useState('')
    const [answer3, setAnswer3] = useState('')
    const [totalShowsPaid, setTotalShowsPaid] = useState()
    const {appInitData, balance, setBalance, setScreenLayout, language} = usePumpStore()
    const [taskLanguage, setTaskLanguage] = useState(language)
    const [errorText, setErrorText] = useState('')


    const createTask = () => {
        if (link.replace(' ', '') === '' || title.replace(' ', '') === '' || correct.replace(' ', '') === '' || title.length > 150 || answer1.replace(' ', '') === '' || answer2.replace(' ', '') === '' || answer3.replace(' ', '') === '' || totalShowsPaid === 0 || totalShowsPaid === '' || balance < (totalShowsPaid * 500)) {
            if (link.replace(' ', '') === '' || title.replace(' ', '') === '' || correct.replace(' ', '') === '' || title.length > 150 || answer1.replace(' ', '') === '' || answer2.replace(' ', '') === '' || answer3.replace(' ', '') === '') {
                if (language === 'RU') {
                    setErrorText('Неверный формат заполнения')
                } else {
                    setErrorText('Incorrect format')
                }
            } else if (balance < (totalShowsPaid * 500)) {
                if (language === 'RU') {
                    setErrorText('Недостаточно баллов')
                } else {
                    setErrorText('Insufficient coins')
                }
            }
        } else {
            setErrorText('')
            let allowCreate = true;
            let optione = []
            if (!optione.includes(correct)) {
                optione.push(correct)
            } else {
                allowCreate = false
            }
            if (!optione.includes(answer1)) {
                optione.push(answer1)
            } else {
                allowCreate = false
            }
            if (!optione.includes(answer2)) {
                optione.push(answer2)
            } else {
                allowCreate = false
            }
            if (!optione.includes(answer3)) {
                optione.push(answer3)
            } else {
                allowCreate = false
            } if (allowCreate) {
                const data = {
                    chat_id: appInitData.user.id,
                    title: title,
                    link: link,
                    correct_answer: correct,
                    answer_1: answer1,
                    answer_2: answer2,
                    answer_3: answer2,
                    totalShowsPaid: totalShowsPaid,
                    language: taskLanguage
                }
                axios.post('https://pump.stt.market/api/create', data).then((res) => {
                    if (res.data.status === 200) {
                        const newBalance = balance - (totalShowsPaid * 500)
                        setBalance(newBalance)
                        setScreenLayout('create')
                    }
                })
            } else {
                if (language === 'RU') {
                    setErrorText('Неверный формат заполнения')
                } else {
                    setErrorText('Incorrect format')
                }

            }

        }

    }

    return (
        <div className={"constructor"}>
            <input type={'text'} className={"constructor__input"} placeholder={Locales[language].adsLink} value={link} onChange={(e) => setLink(e.target.value)}/>
            <textarea rows={3} className={"constructor__textarea"} placeholder={Locales[language].adsQuestion} value={title} onChange={(e) => setTitle(e.target.value)} />
            <div style={{position: "relative", zIndex: 10, height: 65, display: "flex", alignItems: "center", justifyContent: "center", background: 'rgba(255, 255, 255, 0.3)',
                border: 'none',
                outline: 'none',
                padding: '3px 5px',
                borderRadius: 50,
                margin: "auto",
                width: 180
            }}>
                <LanguagePicker
                    current={taskLanguage}
                    available={["EN", "RU"]}
                    direction={"down"}
                    onSave={(lang) => setTaskLanguage(lang)}
                    className={'language_form'}
                />
                <p className={"constructor__text"} style={{fontSize: 14, fontWeight: 400, color: '#ffffff', marginBottom: 0, marginTop: 0, marginLeft: 20, marginRight: 10}}>{Locales[language].adsLanguages}</p>
            </div>
            <p className={"constructor__text"} style={{fontSize: 14, fontWeight: 400, color: '#ffffff'}}>{Locales[language].adsAnswers}</p>
            <div className={"constructor__options"}>
                    <input type={'text'} className={"constructor__input _option"} placeholder={Locales[language].adsCorrect} style={{marginRight: 20, backgroundColor: 'rgb(135,183,153)'}} value={correct} onChange={(e) => setCorrect(e.target.value)}/>

                    <input type={'text'} className={"constructor__input _option"} placeholder={Locales[language].adsFirst} value={answer1} onChange={(e) => setAnswer1(e.target.value)}/>

                    <input type={'text'} className={"constructor__input _option"} placeholder={Locales[language].adsSecond} style={{marginRight: 20}} value={answer2} onChange={(e) => setAnswer2(e.target.value)}/>

                    <input type={'text'} className={"constructor__input _option"} placeholder={Locales[language].adsThird} value={answer3} onChange={(e) => setAnswer3(e.target.value)}/>

            </div>
            {errorText !== '' && <p className={"constructor__text"} style={{fontSize: 12, color: 'red', fontWeight: 400, marginTop: 5}}>{errorText}</p>}
            <p className={"constructor__text"} style={{fontSize: 14, fontWeight: 400, color: '#ffffff'}}>{Locales[language].adsNumber}</p>
            <input type={'number'} className={"constructor__input _number"} placeholder={'0'} style={{width: 80, margin: '10px auto', display: "block"}} value={totalShowsPaid} onChange={(e) => setTotalShowsPaid(e.target.value)}/>
            <p className={"constructor__text"} style={{fontSize: 18, color: '#ffffff', fontWeight: 600, marginTop: 20, marginBottom: 30, display: "flex", alignItems: "center", justifyContent: "center"}}><img src={coin} alt={''} style={{height: 26, marginLeft: 0, marginTop: 0, width: "auto", marginRight: 5}}/> {totalShowsPaid ? 500 * totalShowsPaid : 0}</p>
            <div className={`constructor__button ${(link === '' || title === '' || correct === '' || title.length > 150 || answer1 === '' || answer2 === '' || answer3 === '' || totalShowsPaid === 0 || totalShowsPaid === '' || balance < (totalShowsPaid * 500)) && '_disabled'}`} onClick={createTask} style={{marginBottom: 300}}>{parse(Locales[language].adsPay)}</div>
        </div>
    )
}